export default "__VITE_ASSET__DN4uJv5s__"